import { debounce } from 'lodash-es'
import { useDefaultModal } from './defaultModal'
import Feedback from '@/features/feedback/index.vue'

export const showFeedback = debounce(() => {
  const { $t } = useNuxtApp()

  const cancel = () => {
    modal.destroy()
  }

  const modal = useDefaultModal({
    title: <div>{$t('yi-jian-fan-kui')}</div>,
    width: 656,
    center: true,
    content: <Feedback cancel={cancel} />,
    footer: false,
  })

  return modal
}, 200)
